import { createRouter, createWebHashHistory } from "vue-router";
import Login from "../views/Login.vue";

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/resetpwd",
    name: "restPwd",
    component: () => import("../views/ResetPwd.vue"),
  },
  {
    path: "/myCourese",
    name: "myCourese",
    component: () => import("../views/MyCourese.vue"),
  },
  {
    path: "/myEnrolled",
    name: "myEnrolled",
    component: () => import("../views/MyEnrolled.vue"),
  },
  {
    path: "/enrolledDetail",
    name: "enrolledDetail",
    component: () => import("../views/EnrolledDetail.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("../views/CourseDetail.vue"),
  },
  {
    path: "/allCourses",
    name: "allCourses",
    component: () => import("../views/AllCourses.vue"),
  },

  {
    path: "/child",
    name: "child",
    component: () => import("../views/Child.vue"),
  },
  {
    path: "/user",
    name: "user",
    component: () => import("../views/User.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue"),
  },
  // ---- 新增：账号查看（对齐小程序 account 页） ----
  {
    path: "/account",
    name: "account",
    component: () => import("../views/Account.vue"),
  },
  {
    path: "/jiGouDetail",
    name: "jiGouDetail",
    component: () => import("../views/JiGouDetail.vue"),
  },
  {
    path: "/payment",
    name: "payment",
    component: () => import("../views/Payment.vue"),
  },
  {
    path: "/paymentDetail",
    name: "paymentDetail",
    component: () => import("../views/PaymentDetail.vue"),
  },
  // ---- 新增：老师端路由 ----
  {
    path: "/teacherHome",
    name: "teacherHome",
    component: () => import("../views/TeacherHome.vue"),
  },
  {
    path: "/schedule",
    name: "schedule",
    component: () => import("../views/Schedule.vue"),
  },
  {
    path: "/teacherAttend",
    name: "teacherAttend",
    component: () => import("../views/TeacherAttend.vue"),
  },
  // ---- 新增：教师课时费（占位页，后端接口待接入） ----
  {
    path: "/teacherClassFee",
    name: "teacherClassFee",
    component: () => import("../views/TeacherClassFee.vue"),
  },
  // ---- 新增：家长考勤路由 ----
  {
    path: "/attend",
    name: "attend",
    component: () => import("../views/Attend.vue"),
  },
  // ---- 新增：签到功能路由 ----
  {
    path: "/classList",
    name: "classList",
    component: () => import("../views/ClassList.vue"),
  },
  {
    path: "/studentAttend",
    name: "studentAttend",
    component: () => import("../views/StudentAttend.vue"),
  },
  // ---- 新增：请假路由 ----
  {
    path: "/leaveList",
    name: "leaveList",
    component: () => import("../views/LeaveList.vue"),
  },
  {
    path: "/leaveApply",
    name: "leaveApply",
    component: () => import("../views/LeaveApply.vue"),
  },
  {
    path: "/leaveManage",
    name: "leaveManage",
    component: () => import("../views/LeaveManage.vue"),
  },
  // ---- 新增：班主任班级管理 ----
  {
    path: "/headTeacherClassList",
    name: "headTeacherClassList",
    component: () => import("../views/HeadTeacherClassList.vue"),
  },
  {
    path: "/classStudents",
    name: "classStudents",
    component: () => import("../views/ClassStudents.vue"),
  },
  {
    path: "/studentClassManage",
    name: "studentClassManage",
    component: () => import("../views/StudentClassManage.vue"),
  },
  {
    path: "/classAttendSummary",
    name: "classAttendSummary",
    component: () => import("../views/ClassAttendSummary.vue"),
  },
  // ---- 新增：巡课老师管理 ----
  {
    path: "/dutyInspect",
    name: "dutyInspect",
    component: () => import("../views/DutyInspect.vue"),
  },
  {
    path: "/dutyClassAttend",
    name: "dutyClassAttend",
    component: () => import("../views/DutyClassAttend.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// ---------- 跳转去重 ----------
// 对应小程序 app.js 里劫持 wx.navigateTo / redirectTo 那一层：
// 手抖连点同一个入口时，800ms 内只跳一次，避免同一页面重复入栈。
const NAV_GAP = 800; // 与请求层冷却、小程序端保持一致
let lastNavKey = "";
let lastNavTime = 0;

/** 把跳转目标（字符串或 {path/name, query}）转成用于比对的 key */
function navKey(method, to) {
  if (typeof to === "string") {
    return method + " " + to;
  }
  const target = to.path || to.name || "";
  const params = to.query || to.params || {};
  return method + " " + target + " " + JSON.stringify(params);
}

/**
 * 包装 push / replace，命中去重时返回已完成的 Promise：
 * 不跳转，也不让调用处因为拿到 undefined 而报错。
 */
function wrapNav(method, raw) {
  return function (to) {
    const key = navKey(method, to);
    const now = Date.now();
    if (key === lastNavKey && now - lastNavTime < NAV_GAP) {
      return Promise.resolve();
    }
    lastNavKey = key;
    lastNavTime = now;
    return raw(to);
  };
}

router.push = wrapNav("push", router.push.bind(router));
// go / back 故意不拦：连按返回退多层是正常操作，拦了会变成"点返回没反应"
router.replace = wrapNav("replace", router.replace.bind(router));

/**
 * 获取url的query中的参数
 */
// function getQuery(variable) {
//   var query = window.location.search.substring(1);
//   var vars = query.split("&");
//   for (var i = 0; i < vars.length; i++) {
//     var pair = vars[i].split("=");
//     if (pair[0] == variable) {
//       return pair[1];
//     }
//   }
//   return "";
// }

export default router;
